<script lang="ts">
import { defineComponent } from 'vue';

import { makeLinkProps, makeTextProps, makeThemeProps, provideTheme, useLink } from '../../composable';

export const componentName = 'CdsLink';
export default defineComponent({
  name: componentName,
  props: {
    ...makeTextProps(),
    ...makeLinkProps(),
    ...makeThemeProps()
  },
  emits: {
    /**
     * Событие клика
     *
     * @event click
     */
    click: (event: MouseEvent) => true
  },
  setup(props, { emit }) {
    const { themeClasses } = provideTheme(props);
    const { href, to, tag, handleClick } = useLink(props, emit);

    return {
      tag,
      to,
      href,
      themeClasses,
      handleClick
    };
  }
});
</script>

<template>
  <component :is="tag" :to="to" :href="href" :class="themeClasses" class="cds-link" @click="handleClick">
    {{ text }}
    <!--
      @slot Слот для текста
        @type string
      -->
    <slot />
  </component>
</template>

<style lang="scss">
@import './CdsLink';
</style>
